import ScoreWidget from "components/widgets/ScorePage/widgets/ScoreWidget"
import PropTypes from "prop-types"
import React from "react"
import { useParams } from "react-router-dom"
import "stylesheets/Score.scss"
import classNames from "classnames"
import { useAppContext } from "components/AppContext"
import { useFeatureFlag } from "hooks/useFeatureFlag"
import * as Sentry from "@sentry/react"
import ScoreChartErrorBoundary from "components/ErrorBoundary/ScoreChartErrorBoundary"
import { showMaturity } from "services/score/maturity/showMaturity"

const ScoreLayoutOrganism = ({
  maturity,
  maturityTrendBadge,
  chart1,
  chart2,
  chart3,
  chart4,
  chart5,
  chart6,
  pillarId,
  forceMaturity,
  equalChartWidths,
}) => {
  const { pillarId: urlPillarId } = useParams()
  const { currentRootNode, currentOrganization, currentNode } = useAppContext()
  const { isFeatureActive } = useFeatureFlag()

  const showScoreWidget =
    maturity !== null &&
    !(
      !showMaturity(
        currentOrganization,
        currentRootNode,
        currentNode,
        isFeatureActive
      ) && !forceMaturity
    )

  return (
    <div className="Verdikt-Score">
      <div className={classNames(urlPillarId || pillarId, "page-frame")}>
        <div
          className={classNames("page", {
            "equal-chart-widths": equalChartWidths,
          })}
        >
          <div className="left">
            <div className="row">
              {showScoreWidget && (
                <ScoreWidget 
                  maturity={maturity} 
                  trendBadge={maturityTrendBadge} 
                />
              )}
              <div
                id="widget1"
                className={classNames(
                  urlPillarId || pillarId,
                  "widget",
                  "chart"
                )}
              >
                <Sentry.ErrorBoundary fallback={<ScoreChartErrorBoundary />}>
                  {chart1}
                </Sentry.ErrorBoundary>
              </div>
              <div
                id="widget2"
                className={classNames(
                  urlPillarId || pillarId,
                  "widget",
                  "chart"
                )}
              >
                <Sentry.ErrorBoundary fallback={<ScoreChartErrorBoundary />}>
                  {chart2}
                </Sentry.ErrorBoundary>
              </div>
            </div>
            <div className="row">
              <div
                id="widget4"
                className={classNames(
                  urlPillarId || pillarId,
                  "widget",
                  "chart"
                )}
              >
                <Sentry.ErrorBoundary fallback={<ScoreChartErrorBoundary />}>
                  {chart4}
                </Sentry.ErrorBoundary>
              </div>
              <div
                id="widget5"
                className={classNames(
                  urlPillarId || pillarId,
                  "widget",
                  "chart"
                )}
              >
                <Sentry.ErrorBoundary fallback={<ScoreChartErrorBoundary />}>
                  {chart5}
                </Sentry.ErrorBoundary>
              </div>
            </div>
          </div>
          <div className="right">
            <div
              id="widget3"
              className={classNames(urlPillarId || pillarId, "widget", "chart")}
            >
              <Sentry.ErrorBoundary fallback={<ScoreChartErrorBoundary />}>
                {chart3}
              </Sentry.ErrorBoundary>
            </div>
            <div
              id="widget6"
              className={classNames(urlPillarId || pillarId, "widget", "chart")}
            >
              <Sentry.ErrorBoundary fallback={<ScoreChartErrorBoundary />}>
                {chart6}
              </Sentry.ErrorBoundary>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

ScoreLayoutOrganism.propTypes = {
  maturity: PropTypes.number,
  maturityTrendBadge: PropTypes.object,
  chart1: PropTypes.element.isRequired,
  chart2: PropTypes.element.isRequired,
  chart3: PropTypes.element.isRequired,
  chart4: PropTypes.element.isRequired,
  chart5: PropTypes.element.isRequired,
  chart6: PropTypes.element.isRequired,
  pillarId: PropTypes.string,
  forceMaturity: PropTypes.bool,
  equalChartWidths: PropTypes.bool,
}

ScoreLayoutOrganism.defaultProps = {
  maturity: null,
  maturityTrendBadge: null,
  pillarId: null,
  forceMaturity: false,
  equalChartWidths: false,
}

export default ScoreLayoutOrganism